(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    module.controller('TaskStatesBarController', ['$scope', 'TaskStateEnum','HelperService',
        function ($scope, TaskStateEnum, HelperService) {
            /* jshint validthis:true */
            var vm = this;
            // task states            
            vm.taskStates = HelperService.generateTaskStateArray(vm.isToDo, false);
            
            $scope.$watch('vm.taskState', function(newVal, oldVal) {
                activate();
            });

            activate();

            function activate() {
                // select the task state that is currently set
                    vm.taskStates.forEach(function (state) {
                        state.vmSelected = state.value === vm.taskState;
                    });
            }
            
            vm.select = function (selectedState) {
                /////need this because uib-btn-radio makes problems in ng-repeat

                // deselect
                vm.taskStates.forEach(function (state) {
                    state.vmSelected = false;
                });
                // select current
                selectedState.vmSelected = true;
                // put into model
                vm.taskState = selectedState.value;
            };
        }]);
})();
